export default __webpack_public_path__ + "static/media/plane4.e6176731.jpg";